import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Box, Typography, Chip, Divider } from '@material-ui/core';
import RouterIcon from '@mui/icons-material/Router';
import { useHistory } from 'react-router-dom';
import { getIotDevicesByAccount, clearAccountIotDevices } from 'redux/actions/iotDevices/iotDevicesActions';
import { useRuleValidator } from 'hooks/useRuleValidator';
import { PERMISSIONS } from 'router/permissions';

const STATUS_COLOR = { ACTIVE: '#2e7d32', INACTIVE: '#c62828', MAINTENANCE: '#e65100', RETIRED: '#616161' };

export const CustomerIotDevices = () => {
  const dispatch = useDispatch();
  const hist = useHistory();
  const { account } = useSelector(({ customersReducer }) => customersReducer);
  const { accountIotDevices } = useSelector(({ iotDevices }) => iotDevices);
  const canView = useRuleValidator(PERMISSIONS.IOT_DEVICES);

  useEffect(() => {
    if (account?.id && canView) {
      dispatch(clearAccountIotDevices());
      dispatch(getIotDevicesByAccount(account.id));
    }
  }, [account?.id]);

  if (!canView || !account?.id) return null;

  return (
    <Box mt={1}>
      <Box display="flex" alignItems="center" gap={1} mb={0.5}>
        <RouterIcon style={{ fontSize: 16, color: '#004F9F' }} />
        <Typography variant="caption" style={{ fontWeight: 600, color: '#004F9F' }}>
          Dispositivos IoT
        </Typography>
      </Box>
      <Divider style={{ marginBottom: 6 }} />
      {accountIotDevices.length === 0 ? (
        <Typography variant="caption" color="textSecondary">Sin dispositivos vinculados</Typography>
      ) : (
        accountIotDevices.map(device => (
          <Box
            key={device.id}
            display="flex"
            justifyContent="space-between"
            alignItems="center"
            py={0.5}
            style={{ cursor: 'pointer' }}
            onClick={() => hist.push(`/admin/iot-device/${device.id}`)}
          >
            <Box>
              <Typography variant="caption" style={{ fontWeight: 500 }}>
                {device.iotIdentity}
              </Typography>
              <Typography variant="caption" color="textSecondary" display="block">
                {device.tank?.serie ?? 'Sin tanque'} {device.lastMeasurement ? `· ${device.lastMeasurement.levelPct}%` : ''}
              </Typography>
            </Box>
            <Chip
              label={device.status}
              size="small"
              style={{
                backgroundColor: STATUS_COLOR[device.status] ?? '#555',
                color: '#fff',
                fontSize: 10,
                height: 18,
              }}
            />
          </Box>
        ))
      )}
    </Box>
  );
};
